import { render, staticRenderFns } from "./Recommend03.vue?vue&type=template&id=a743cdd8&"
import script from "./Recommend03.vue?vue&type=script&lang=js&"
export * from "./Recommend03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports